import { useEffect } from 'react';

const DEFAULT_TITLE = 'かまた祭2025 公式サイト';
const DEFAULT_DESCRIPTION =
  '日本工学院専門学校 蒲田キャンパス × 東京工科大学 蒲田キャンパス 「かまた祭」の公式サイトです。2025年の開催情報、イベントスケジュール、売店・模擬店情報、アクセス方法などをご案内しています。';

interface PageMetaOptions {
  title?: string;
  description?: string;
}

export const usePageMeta = (options: PageMetaOptions | string = {}) => {
  // 後方互換性のため、文字列が渡された場合はタイトルとして扱う
  const meta = typeof options === 'string' ? { title: options } : options;

  useEffect(() => {
    // タイトルの設定
    const title = meta.title ? `${meta.title} | ${DEFAULT_TITLE}` : DEFAULT_TITLE;
    document.title = title;

    // ディスクリプションの設定
    const description = meta.description || DEFAULT_DESCRIPTION;
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    }

    // OGPディスクリプションも更新
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', description);
    }

    // Twitter Card ディスクリプションも更新
    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute('content', description);
    }

    // クリーンアップ: コンポーネントがアンマウントされたときにデフォルトに戻す
    return () => {
      document.title = DEFAULT_TITLE;
      if (metaDescription) {
        metaDescription.setAttribute('content', DEFAULT_DESCRIPTION);
      }
      if (ogDescription) {
        ogDescription.setAttribute('content', DEFAULT_DESCRIPTION);
      }
      if (twitterDescription) {
        twitterDescription.setAttribute('content', DEFAULT_DESCRIPTION);
      }
    };
  }, [meta.title, meta.description]);
};

// 後方互換性のためのエクスポート
export const usePageTitle = usePageMeta;

export default usePageMeta;
